import React from 'react';

const CarHireBanner = () => {
    return (
        <section 
            className="banner__one" 
            style={{
                background: "linear-gradient(rgba(45, 56, 80, 0.6), rgba(45, 56, 80, 0.6)), url('assets/images/banner/car-hire-banner.jpg')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-lg-10">
                        <div className="banner__one-content text-center">
                            <h6 className="text-white mb-3">
                                Compare & Save on Car Rentals
                            </h6>
                            <h1 className="text-white mb-4">
                                Find Your Perfect Rental Car
                            </h1>
                            <p className="text-white mb-5">
                                Search, compare and book from hundreds of car rental companies worldwide. 
                                Get the best deals on economy, luxury, and specialty vehicles.
                            </p>
                            <div className="banner__one-btn">
                                <a href="#search" className="btn-one">
                                    Search Cars <i className="fas fa-chevron-right"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="banner__one-shape">
                <img src="assets/images/banner/banner-one-shape.png" alt="shape" />
            </div>
        </section>
    );
};

export default CarHireBanner;
